import { defineComponent as n, openBlock as i, createBlock as r, unref as a, withCtx as f, createElementVNode as t } from "vue";
import l from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as s } from "@storefront-ui/shared";
const c = /* @__PURE__ */ n({
  __name: "SfIconInfo",
  props: {
    size: {
      type: String,
      default: s.base
    }
  },
  setup(o) {
    return (d, e) => (i(), r(a(l), {
      size: o.size,
      viewBox: "0 0 24 24",
      "data-testid": "info"
    }, {
      default: f(() => e[0] || (e[0] = [
        t("path", { d: "M13.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M11 16a1 1 0 1 0 2 0v-4a1 1 0 1 0-2 0z" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12m2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  c as default
};
